var app = angular.module("leonardo");

var SectorEditDialog = function($scope, $rootScope, SectorRestService, FormErrorsService) {
  $scope.isEdit = $scope.ngDialogData.sector? true : false;
  $scope.sector = angular.copy($scope.ngDialogData.sector);
  $scope.submit = function() {
    $scope.Form.$setSubmitted();

    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    var data = $scope.getData();

    if ($scope.isEdit) {
      $scope.sector.patch(data).then(function () {
        $rootScope.$broadcast('sector:changed');
        $scope.closeThisDialog();
      });
    }
    else {
      data.key = data.name.toLowerCase().replace(/[^a-zA-Z0-9]+/g, "-");

      SectorRestService.post(data).then(function (result) {
        SectorRestService.updateCollection(result);
        $rootScope.$broadcast('sector:changed');
        $scope.closeThisDialog();
      });
    }
  };

  $scope.getData = function() {
    return {
      name: $scope.sector.name
    };
  };
};

app.controller('SectorEditDialog', ['$scope', '$rootScope', 'SectorRestService', 'FormErrorsService', SectorEditDialog]);
